import React from 'react';

import { Box, Grid } from '@mui/material';

import ProfileLocationMapView from '../ProfileLocationMapView/ProfileLocationMapView';
import { formGenerator } from '../../../../helpers/formGenerator';
import CustomRadioTable from '../../../common/CustomRadioTable';
import CustomButton from '../../../common/CustomButton';
import strings from '../../../../localization';

import classes from './style';

interface IProfileTitle {
  title: string;
  formik: any;
  items: any;
  table?: boolean;
  map?: boolean;
  hideSave?: boolean;
  isSignup?: boolean;
  setSelected?: any;
  disableSave?: boolean;
}

const defaultProps = {
  table: false,
  map: false,
  hideSave: false,
  isSignup: false,
  setSelected: null,
};

const ProfileFormGenerator = ({
  formik,
  items,
  title,
  table,
  map,
  hideSave,
  isSignup,
  setSelected,
  disableSave,
}: IProfileTitle) =>
  (
    <Box sx={classes.profileFormContainer}>
      <Grid container>
        {title && (
        <Grid sx={classes.mainHeader} xs={12}>
          {title}

          <Box component="span" sx={classes.profileTitleLine} />
        </Grid>
        )}
        <Grid container xs={12}>
          {table ? (
            <Grid item xs={12}>
              <CustomRadioTable
                formik={formik}
                isSignup={isSignup}
              />
            </Grid>
          ) : (
            items?.map((item: any) =>
              formGenerator(item, formik))
          )}
        </Grid>
        <Grid container xs={12}>
          {map && (
          <Grid item xs={12}>
            <ProfileLocationMapView setSelected={setSelected} />
          </Grid>
          )}
        </Grid>
        {!hideSave && (
        <Grid sx={classes.buttonContainer} container>
          <CustomButton
            disabled={disableSave}
            onClick={formik?.handleSubmit}
            label={strings.save}
          />
        </Grid>
        )}
      </Grid>
    </Box>
  );
ProfileFormGenerator.defaultProps = defaultProps;

export default ProfileFormGenerator;
